import React, { Component } from 'react';
import { connect } from 'react-redux';
import { map } from 'lodash';
import { bindActionCreators } from 'redux';
import { loginWithTokens } from '../../../redux/actions';
import { withRouter } from 'react-router-dom';
import { Card, CardBody,  CardHeader  } from 'reactstrap';

class LoginWithToken extends Component {
  componentDidMount() {
    const queryString = (new URL(window.location)).search;
    if(queryString && queryString.length > 0) {
      const queryStringArray = decodeURI(queryString).slice(1).split('&');

      let tokens = {};
      map(queryStringArray, queryString => {
        const param = queryString.split('=');
        if(
          param[0] === 'id_token' ||
          param[0] === 'access_token' ||
          param[0] === 'refresh_token'
        ) {
          tokens[param[0]] =  param[1];
        }
      });

      if (tokens && Object.keys(tokens).length > 0) {
        this.props.loginWithTokens(tokens, this.props.history);
      } else {
        this.props.history.push('/');
      }
    } else {
      this.props.history.push('/');
    }
  }

  render() {
    return (
            <div>
                       <Card>
                          <CardHeader>
                            <i className="fa fa-spinner"></i> Loading User Data
                          </CardHeader>
                          <CardBody>
                            <div className="sk-rotating-plane"></div>
                          </CardBody>
                       </Card>
            </div>
        );
  }
}

function mapStateToProps({ }) {
  return { };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    loginWithTokens
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginWithToken));
